import { createEffect, Actions, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { UserService } from '@app/common/services/user.service';
import { UserActionType, GetAuthUserAction, GetAuthUserErrorAction, GetAuthUserActionDone, LogUsersClientErrorAction, LogUsersClientErrorActionDone } from './actions';
import { switchMap, map, withLatestFrom, catchError, tap } from 'rxjs/operators';
import { AuthService } from 'FoxxyLib';
import { Store, select } from '@ngrx/store';

import { IAuthUser, IClientError } from 'FoxxyInterfaces';
import { Observable, of } from 'rxjs';
import { SettingService } from '@app/common/services/setting.service';
import { SignalMessageService } from '@app/common/services/signalmessage.service';
import { GeneralResultEnum } from '@app/common/models';
import { CommonCheckService } from 'FoxxyLib';
import { InitialUserState, UserState } from './state';

@Injectable()
export class UserEffects {

  state$ : Observable<UserState> = of(InitialUserState);
  actions = inject(Actions);


  constructor(
    private store: Store<any>,
    private userservice: UserService,
    private settingservice: SettingService,
    private authService: AuthService,
    private lipocheck: CommonCheckService,
    private  convertlipo : CommonCheckService
  ) {

    this.state$ = this.store.select(state => state.AppState);

  }


  getAuthUserEffect$ = createEffect(() => { return  this.actions.pipe(
    ofType<GetAuthUserAction>(UserActionType.GetAuthUserAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.authService.claims$.pipe(
        map(f => {
          const usermodel = <IAuthUser>{ name: f.name, id: f.sub, client_id: f.client_id, member_of: f.member_of, shortId: this.lipocheck.getShortUserid(f.sub) }
          return new GetAuthUserActionDone({ user: usermodel });
        })
      )
    ), catchError((error, caught) => {
            this.store.dispatch(new GetAuthUserErrorAction({ error: error }));
            return caught;
    })
  )})





  logClientUserErrorEffect$ = createEffect(() => { return  this.actions.pipe(
    ofType<LogUsersClientErrorAction>(UserActionType.LogUsersClientErrorAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.settingservice.logClientError(<IClientError>{
        error: this.convertlipo.stringify(action.payload.error.error),
        modul: action.payload.error.modul, userid: action.payload.error.userid
      }
      ).pipe(
        map(f => {
          return new LogUsersClientErrorActionDone({ error: action.payload.error });
        })
        , catchError(error => {
          console.debug("While Loggging getting Error: " + JSON.stringify(error));
          return of();
        }
        )
      )
    )
  )})



}



